import { ApiError } from '../errors/ApiError';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

export const codeyApiClient = {
  defaults: { baseUrl: BASE_URL },

  async get<Output>(endpoint: string, options?: RequestOptions): Promise<Output> {
    const result = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'GET',
      headers: buildHeaders(options),
    });

    if (result.ok) {
      return result.json();
    } else {
      throw new ApiError(`GET request to ${endpoint} failed`, result.status);
    }
  },

  async post<Input, Output>(endpoint: string, data: Input, options?: RequestOptions): Promise<Output> {
    const result = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: buildHeaders(options, data),
      body: data instanceof FormData ? data : JSON.stringify(data),
    });

    if (result.ok) {
      return result.json();
    } else {
      throw new ApiError(`POST request to ${endpoint} failed`, result.status);
    }
  },

  async put<Input, Output>(endpoint: string, data: Input, options?: RequestOptions): Promise<Output> {
    const result = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'PUT',
      headers: buildHeaders(options, data),
      body: data instanceof FormData ? data : JSON.stringify(data),
    });

    if (result.ok) {
      return result.json();
    } else {
      throw new ApiError(`PUT request to ${endpoint} failed`, result.status);
    }
  },

  async delete(endpoint: string, options?: RequestOptions): Promise<void> {
    const result = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'DELETE',
      headers: buildHeaders(options),
    });

    if (!result.ok) {
      throw new ApiError(`DELETE request to ${endpoint} failed`, result.status);
    }
  },
};

function buildHeaders(options?: RequestOptions, body?: unknown): HeadersInit {
  const isFormData = body instanceof FormData;
  let headers: HeadersInit = isFormData ? {} : { ...DEFAULT_HEADERS };

  if (options?.authToken) {
    headers['Authorization'] = `Bearer ${options.authToken}`;
  }

  if (options?.headers) {
    headers = { ...headers, ...options.headers };
  }

  return headers;
}

type RequestOptions = {
  authToken?: string;
  headers?: HeadersInit;
};
